/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
import { Card, Classes, Elevation, H6, ICardProps } from '@blueprintjs/core';
import * as moment from 'moment';

type MetaDataObject = {
	[itemLabel: string]: string | Date | number,
};

interface MetaDataViewerProps extends React.ComponentPropsWithoutRef<'div'> {
	title?: string;
	content?: MetaDataObject;
	dateFormatter?: string,
}

export const MetaDataViewer: React.FC<MetaDataViewerProps> = ({
	title,
	content,
	dateFormatter = 'HH:MM:SS MM/DD/YYYY (UTC)',
	...props
}) => {
	if (!(title && content)) return null
	return (
		<div {...props}>
			{title && (
				<H6>
					<span cy-test="chart-tooltip-title">{title}</span>
				</H6>
			)}
			{content && (
				<ul className={[Classes.TEXT_SMALL, Classes.LIST_UNSTYLED].join(' ')}>
					{Object.keys(content).map((item, index) => {
						let formattedItem = content[item];
						if (formattedItem == null) return null
						// if (typeof formattedItem === 'object') { // do we need this?
						if (moment.isDate(formattedItem)) {
							formattedItem = moment.utc(formattedItem).format(dateFormatter)
						}
						// }
						return (
							<li key={index} css={tooltipStyle.item}>
								<span css={tooltipStyle.label}>{item}:</span>
								<span cy-test={`chart-tooltip-${item}`} css={tooltipStyle.value}>{formattedItem}</span>
							</li>
						);
					})}
				</ul>
			)}
		</div>
	);
}

const tooltipStyle = {
	item: css`
		display: flex;
		justify-content: space-between;
	`,
	label: css`
		font-weight: bold;
		padding-right: 10px;
	`,
	value: css``,
};

interface ChartToolTipProps extends MetaDataViewerProps { }

export function ChartTooltip({ content, title, dateFormatter, children, ...props }: ChartToolTipProps) {
	return (
		<Card elevation={Elevation.THREE} cy-test="chart-tooltip" {...props}>
			<MetaDataViewer {...{ content, title, dateFormatter }} />
			{children}
		</Card>
	);
}

export default ChartTooltip;
